import { loadSeigyoConfig, maintenanceMiddleware } from '@npm/seigyo-maintenance-mode';
import { seigyoMpcUrl, seigyoMcaUrl } from '@/utils/envs';
import { COUNTRIES } from '@/utils/constants';
import { isMCA, state } from '@/store';

const seigyoMiddleware = async (to, from, next) => {
  const currentCountry = state.country.pais;
  const seigyoUrl = isMCA() ? seigyoMcaUrl : seigyoMpcUrl;
  const crExtension = '.cr';

  const URL = seigyoUrl
    .replace('{country}', currentCountry.toLowerCase())
    .replace('.com.cr', crExtension);

  const config = {
    URL,
    ActiveCountry: currentCountry,
    Countries: Object.keys(COUNTRIES)
  };

  const seigyoConfig = await loadSeigyoConfig(config);

  maintenanceMiddleware(to, from, next, seigyoConfig);
};

export default seigyoMiddleware;

